<template>
    <div class="recommend_stat">
        <div class="classify">
           <div class="chead">
               <span class="left theme">一级用户</span>
               <p class="left">
                   <span style="margin:0 40px;">{{recommendNum.valueFour}} ( 人 )</span>
                   <span class="button" v-if="recommendNum.first > 0">( 查看全部用户 )</span>
               </p>
           </div>
            <ul class="list" v-show="false">
                <li class="title">
                    <p>客户编号</p>
                    <p>推荐时间</p>
                </li>
                <li class="content">
                    <span class="num">131456789852</span>
                    <span class="times">2018-5-12</span>
                </li>
            </ul>
        </div>
        <div class="classify">
            <div class="chead">
                <span class="left theme">二级用户</span>
                <p class="left">
                    <span style="margin:0 40px;">{{recommendNum.valueFive}} ( 人 )</span>
                    <span class="button" v-if="recommendNum.valueFive > 0">( 查看全部用户 )</span>
                </p>
            </div>
            <ul class="list" v-show="false">
                <li class="title">
                    <p>客户编号</p>
                    <p>推荐时间</p>
                </li>
                <li class="content">
                    <span class="num">131456789852</span>
                    <span class="times">2018-5-12</span>
                </li>
            </ul>
        </div>
        <div class="classify">
          <div class="chead">
            <span class="left theme">返现总额</span>
            <p class="left">
              <span style="margin:0 40px;">{{recommendNum.valueOne}} ( 元 )</span>
            </p>
          </div>
        </div>
        <div class="classify">
          <div class="chead">
            <span class="left theme">未提现金额</span>
            <p class="left">
              <span style="margin:0 40px;">{{recommendNum.valueTwo}} ( 元 )</span>
            </p>
          </div>
        </div>
    </div>
</template>
<script>
    import { util } from '../service/util'
    let API = util.api([
        'GETRETURNCASHINFO'
    ])
    export default{
        data(){
            return {
                recommendNum:{
                    valueOne:0,
                    valueTwo:0,
                    valueThree:0,
                    valueFour:0,
                    valueFive:0,
                }
            }
        },
        methods: {
            // 推荐统计
            recommend(){
                let _this = this;
                util.kAjax(API.GETRETURNCASHINFO,{},res=>{
                    _this.recommendNum = {
                      ..._this.recommendNum,
                      ...res.data
                    }
//                   _this.recommendNum.first = res.data.valueFour;
//                   _this.recommendNum.second = res.data.valueFive;
                })
            }
        },
        mounted(){
            this.recommend();
        }
    }
</script>



// WEBPACK FOOTER //
// RecommendStat.vue?162dc8c0